/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { getDownloadURL } from "firebase/storage";
import { Button } from "@material-ui/core";
import Page from "components/common_components/Page/Page";
import useStyles from "../useStyles";
import { useDispatch } from "react-redux";
import { notifyError, notifyInfo, notifySuccess } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import ModulesContext from "../ModulesContext";
import Grid from "@material-ui/core/Grid";
import { DropzoneArea } from "material-ui-dropzone";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import AttachFileTwoToneIcon from "@material-ui/icons/AttachFileTwoTone";
import CloudUploadTwoToneIcon from "@material-ui/icons/CloudUploadTwoTone";
import CancelTwoToneIcon from "@material-ui/icons/CancelTwoTone";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress";

function Attachments({ onCancel }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [filesToUpload, setFilesToUpload] = useState([]);
    const [showDragzone, setShowDragzone] = useState(false);
    const [selectedFile, setSelectedFile] = useState(undefined);
    const [isUploading, setIsUploading] = useState(false);

    const { Attachments, currentFileCase, isLoading, attachments, getAttachmentsAsync, Storage, module } = useContext(
        ModulesContext,
    );

    function initAttachFile() {
        setFilesToUpload([]);
        setSelectedFile(undefined);
        setShowDragzone(true);
    }

    function cancelAttachFile() {
        setFilesToUpload([]);
        setSelectedFile(undefined);
        setShowDragzone(false);
    }

    useEffect(() => {
        if (!currentFileCase) {
            dispatch(notifyError("You have to select a client file first!"));
            onCancel();
        }
    }, [currentFileCase]);

    function onDeleteSuccess(file) {
        dispatch(notifyInfo("Removed successfully!"));
        setSelectedFile(undefined);
        getAttachmentsAsync();
        Storage.deleteAsync({
            path: `modules/${module.dbName}/attachments/${currentFileCase.id}/${file.name}`,
        });
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(file) {
        Attachments.deleteAll({
            ids: [file.id],
            onSuccess: () => onDeleteSuccess(file),
            onError: onDeleteError,
        });
    }

    async function onSubmitHandler() {

        const requests = [];

        filesToUpload.forEach((file) => {
            const request = new Promise(async (resolve, reject) => {
                try {
                    const snap = await Storage.uploadAsync({
                        path: `modules/${module.dbName}/attachments/${currentFileCase.id}/${file.name}`,
                        file,
                    });
                    const url = await getDownloadURL(snap.ref);
                    const response = await Attachments.addAsync({
                        name: file.name,
                        url,
                        date: new Date().getTime(),
                        fileCaseId: currentFileCase.id,
                    });
                    if (response && response.status === 200) {
                        resolve(response);
                    } else {
                        reject({httpError: undefined, data: file, message: `Error uploading the file ${file.name}`});
                    }
                } catch (error) {
                    reject({httpError: error, data: file, message: `Error uploading the file ${file.name}`});
                }
            });

            requests.push(request);
        });

        if (requests.length > 0) {
            setIsUploading(true);
            Promise.all(requests)
                .then((responses) => {
                    dispatch(notifySuccess(`Uploaded successfully!`));
                    cancelAttachFile();
                    getAttachmentsAsync();
                })
                .catch((error) => {
                    dispatch(notifyError(error.message));
                }).finally(()=>{
                    setIsUploading(false);
                })
        }
    }

    function handlePreviewIcon(fileObject, classes) {
        const iconProps = {
            className: classes.image,
        };

        return <PictureAsPdfIcon {...iconProps} />;
    }

    

    return (
        <Page className={classes.root}>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <Grid container>
                    <Grid item xs={6}>
                        {!showDragzone && (
                            <Button
                                variant="text"
                                size="small"
                                color="primary"
                                startIcon={<AttachFileTwoToneIcon />}
                                onClick={initAttachFile}
                            >
                                Attach file
                            </Button>
                        )}
                        {showDragzone && (
                            <Button
                                variant="text"
                                size="small"
                                color="default"
                                startIcon={<CancelTwoToneIcon />}
                                onClick={cancelAttachFile}
                            >
                                Cancel
                            </Button>
                        )}
                    </Grid>
                    {showDragzone && (
                        <Grid item xs={12}>
                            <DropzoneArea
                                onChange={setFilesToUpload}
                                maxFileSize={10490000} // 10MB
                                acceptedFiles={["application/pdf"]}
                                getPreviewIcon={handlePreviewIcon}
                                showFileNames
                                showFileNamesInPreview
                                clearOnUnmount
                            />
                        </Grid>
                    )}
                    <Grid container justifyContent="center" style={{ paddingTop: 20 }}>
                        {showDragzone && filesToUpload.length > 0 && !isUploading && (
                            <Button
                                variant="text"
                                size="large"
                                color="primary"
                                startIcon={<CloudUploadTwoToneIcon />}
                                onClick={onSubmitHandler}
                            >
                                Upload
                            </Button>
                        )}
                        {isUploading && <CircularProgress />}
                    </Grid>
                    {attachments && attachments.length > 0 && !showDragzone && (
                        <Grid container direction="row">
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={4}
                                xl={4}
                                style={{ borderWidth: 1, borderStyle: "solid", borderColor: "rgba(0, 0, 0, 0.12)" }}
                            >
                                <List dense>
                                    {attachments.map((file, index) => (
                                        <ListItem
                                            key={index}
                                            button
                                            onClick={() => setSelectedFile(file)}
                                            selected={selectedFile && file.id === selectedFile.id}
                                        >
                                            <ListItemIcon>
                                                <PictureAsPdfIcon style={{ color: "rgba(187, 9, 9, 0.87)" }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={file.name}
                                                secondary={file.dateString}
                                                primaryTypographyProps={{ style: { fontSize: 12 } }}
                                                secondaryTypographyProps={{ style: { fontSize: 10 } }}
                                            />
                                            <ListItemSecondaryAction>
                                                <IconButton edge="end" aria-label="delete" onClick={() => onDeleteHandler(file)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                                {selectedFile && (
                                    <iframe
                                        src={selectedFile ? selectedFile.url : undefined}
                                        frameBorder="0"
                                        title="Viewer"
                                        width="100%"
                                        height="900px"
                                    />
                                )}
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            )}
        </Page>
    );
}

Attachments.propTypes = {
    onCancel: PropTypes.func,
};

Attachments.defaultProps = {
    onCancel: () => {},
};

export default withRouter(Attachments);
